import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from '../../commons/useTranslasion';
import { Container, CurrentLanguage, LanguageList, LanguageOption } from './styles';

const languages = [
    {
        code: 'pt-br',
        name: 'Português',
        flag: 'https://flagcdn.com/w20/br.png'
    },
    {
        code: 'es-ar',
        name: 'Español',
        flag: 'https://flagcdn.com/w20/ar.png'
    }
];

const LanguageSelector: React.FC = () => {
    const { language, changeLanguage } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const currentLanguage = languages.find(lang => lang.code === language) || languages[0];

    const handleLanguageChange = (languageCode: string) => {
        if (languageCode !== language) {
            changeLanguage(languageCode);
        }
        setIsOpen(false);
    };

    useEffect(() => {
        if (!isOpen) return;
        
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);
    
    const renderDropdown = () => {
        if (!isOpen) return null;
        
        const position = containerRef.current?.getBoundingClientRect();
        
        if (!position) return null;
        
        const dropdownStyle = {
            position: 'fixed' as 'fixed',
            top: `${position.bottom + window.scrollY + 4}px`,
            right: `${window.innerWidth - position.right}px`,
            zIndex: 9999
        };
        
        return ReactDOM.createPortal(
            <LanguageList isOpen={true} style={dropdownStyle}>
                {languages.map((lang) => (
                    <LanguageOption
                        key={lang.code}
                        onClick={() => handleLanguageChange(lang.code)}
                    >
                        <img 
                            src={lang.flag} 
                            alt={lang.name}
                            loading="lazy"
                        />
                        <span>{lang.name}</span>
                    </LanguageOption>
                ))}
            </LanguageList>,
            document.body
        );
    };

    return (
        <Container ref={containerRef}>
            <CurrentLanguage onClick={() => setIsOpen(!isOpen)}>
                <img 
                    src={currentLanguage.flag} 
                    alt={currentLanguage.name}
                    loading="lazy"
                />
            </CurrentLanguage>
            
            {renderDropdown()}
        </Container>
    );
};

export default LanguageSelector;
